{
  "declineButton": "Decline",
  "iAgree": "I agree",
  "linkTo": "View Terms of Service",
  "title": "Terms of Service"
}
